import {Component, OnInit, OnDestroy} from '@angular/core';
import {BekocheckConstants} from '../bekocheck.constants';
import {StepService} from '../../services/step.service';
import {Router} from '@angular/router';
import {BekocheckRequestService} from '../services/request.service';
import {ElementService} from '../../services/element.service';
import {DecimalPipe} from '@angular/common';
import {EingabeStepComponent} from '../eingabe/eingabe.step.component';
import {MathService} from '../services/math.service';
import {PortalService} from '../../services/portal.service';
import {MatDialog} from '@angular/material/dialog';
import {EmbedService} from '../../services/embed.service';
import {TranslateService} from "@ngx-translate/core";
import { Subscription } from 'rxjs';

/**
 *
 */
@Component({
    selector: 'app-bekocheck-ergebnis',
    templateUrl: './ergebnis.component.html',
    providers: [DecimalPipe],
    standalone: false
})
export class ErgebnisComponent extends EingabeStepComponent implements OnInit, OnDestroy {

  /**
   * the object of the result, from anfrge object
   */
  result: any;

  /**
   * some placeholders for the texts
   */
  placeholder: {};

  /**
   * The stage that we need for the texts
   */
  stage: number = null;

  /**
   * list of available tipps
   */
  tipps: any = {
    betriebskosten: [
    {name: 'heizenergieverbrauch', icon: 'tipps-heating-type', url: 'bekocheck.ergebnis.tipp.heizenergieverbrauch.buttonlink'},
    {name: 'warmwasserkosten', icon: 'save-water', url: 'bekocheck.ergebnis.tipp.warmwasserkosten.buttonlink'},
    {name: 'mieter', icon: 'money-coins', url: 'bekocheck.ergebnis.tipp.mieter.buttonlink'},
    {name: 'beratung', icon: 'handshake', url: 'bekocheck.ergebnis.tipp.beratung.buttonlink'},
    ]
  };

  /**
   * data for the dialog registration
   */
  dialogData: any = {};

  /**
   * Toggle to force the Dialog/NL-Box
   */
  forceDialog: boolean = false;

  /**
   * will be set to true if there is an error while talking to the backend.
   */
  hasError = null;

  /**
   * current portalId
   */
  portalId: string;

  /**
   * toggle if this is an internal project or not.
   */
  internalPortal: boolean;

  /**
   * hide report download
   */
  hideReportDownload: boolean;

  /**
   * toggle if we want to display the download module
   */
  showDownload: boolean;

  /**
   * Configuration for the partner teaser
   */
  partnerTeaser: {headline: string, text: string, hideImage: boolean, buttonLink: string, buttonText: string };

  /**
   * toggle for the reset button at the end of the page.
   */
  showResetButton: boolean = false;

  /**
   * holds the urls to other advisors
   */
  advisorUrls: {hec: string | null, wwc: string | null };

  /**
   * list of subscriptions that we unsubscribe on destroy
   */
  subscriptions: Subscription[] = [];

  /**
   * @inheritDoc
   */
  constructor(protected stepService: StepService, protected router: Router, protected requestService: BekocheckRequestService,
              protected elementService: ElementService, protected portalService: PortalService, private decimalPipe: DecimalPipe,
              public dialog: MatDialog, private embedService: EmbedService, private translate: TranslateService) {
    super(stepService, router, requestService, elementService, portalService);
  }

  /**
   * @inheritDoc
   */
  ngOnInit() {
    super.ngOnInit();

    if(!this.anfrage.result || Object.keys(this.anfrage.result).length === 0) {
      this.hasError = true;
    }

    // get the current portalId
    this.portalId = this.portalService.currentPortalId;
    this.internalPortal = this.portalService.isInternalPortal();
    this.hideReportDownload = this.portalService.getConfigAsBool('embed.newsletter.report.download');
    this.showDownload = !this.hideReportDownload && !this.internalPortal;

    // should we force to see the dialog box
    this.forceDialog = this.portalService.getConfigAsBool('embed.newsletter.force');

    // show the resetbutton
    this.showResetButton = this.portalService.getConfigAsBool('bekocheck.enable.resetrequest');

    // check if we have a partner teaser
    if (this.portalService.getConfig('bekocheck.lastpage.teaser.headline')) {
      this.partnerTeaser = {
        headline: this.portalService.getConfig('bekocheck.lastpage.teaser.headline'),
        text: this.portalService.getConfig('bekocheck.lastpage.teaser.text'),
        hideImage: this.portalService.getConfigAsBool('bekocheck.lastpage.teaser.hideimage'),
        buttonText: this.portalService.getConfig('bekocheck.lastpage.teaser.buttontext'),
        buttonLink: this.portalService.getConfig('bekocheck.lastpage.teaser.buttonlink')
      };
    }

    this.requestService.backendService.getRequestId().subscribe(requestId => {
      // recalculate result
      this.requestService.backendService.result(this.anfrage, requestId).subscribe(data => {
        //check if we get a result from the backend
        if(data?.result?.costItems?.length > 0) {
          this.anfrage.result = data;
          this.hasError = false;
        }
      }, () => {
        this.hasError = true;
      });
    }, () => {
      // an error occured while talking to the backend.
      this.hasError = true;
    });

    this.initDialogData();
    this.calculateResult();
    // prepare some placeholder for the texts
    this.placeholder = {
      countOfItems: this.result.countOfItems,
      countOfOverAverage: this.result.countOfOverAverage,
      mehrkostenGebaeude: this.decimalPipe.transform(this.result.mehrkostenGebaeude, '1.0-0')
    };
    this.tipps.betriebskosten.forEach((tipp) => {
      if (tipp.hasOwnProperty('url')) {
        const subscription = this.translate.get(tipp.url).subscribe(translated => {
          tipp.url = translated;
        });
        this.subscriptions.push(subscription);
      }
    });

    // get the advisor urls
    this.advisorUrls = {
      hec: this.portalService.getConfig("alladvisors.link.heizcheck")?.replace(/\{\{portalId}}/, this.portalService.currentPortalId) ?? null,
      wwc: this.portalService.getConfig("alladvisors.link.wassercheck")?.replace(/\{\{portalId}}/, this.portalService.currentPortalId) ?? null
    }
  }

  /**
   * @inheritDoc
   */
  ngOnDestroy() {
    // unsubscribe from subscriptions
    this.subscriptions.forEach(subscription => subscription.unsubscribe());
  }

  /**
   * Updates the stage value
   */
  setStage(stage: number) {
    this.stage = stage;
  }

  /**
   * Get value from user input
   * @param key Property name
   */
  getUserValue(key: string): any {
    return this.anfrage.userInput.hasOwnProperty(key) ? this.anfrage.userInput[key] : null;
  }

  /**
   * Set the value of the field
   * @param key Property name
   * @param value New value
   */
  setUserValue(key: string, value: any): void {
    this.anfrage.userInput[key] = value;
  }


  calculateResult(): void {
    this.result = {
      countOfVisibleItems: 6,
      costItems: [],
      isApartementBuilding: this.getUserValue('gebaeudetyp') === 'mehrfamilienhaus',
      countOfOverAverage: 0,
      maxValue: 0
    };
    let sumAverage = 0;
    let sumUserAverage = 0;
    Object.entries(BekocheckConstants.VERGLEICHSKOSTEN).forEach(([key, average]) => {
      let image = null;
      let userValue = 0;
      let buttonlink = null;
      switch (key) {
        case 'kaltwasser_abwasser':
          if (this.getUserValue('kosten_kaltwasser') > 0) {
            userValue = this.getUserValue('kosten_kaltwasser') + this.getUserValue('kosten_abwasser') + this.getUserValue('kosten_niederschlagswasserentsorgung');
          }
          else if (this.getUserValue('kosten_abwasser_kaltwasser') > 0) {
            userValue = this.getUserValue('kosten_abwasser_kaltwasser');
          }
          break;
        case 'heizung_warmwasser':
          if (this.getUserValue('kosten_heizung') > 0 || this.getUserValue('kosten_warmwasser') > 0) {
            userValue = this.getUserValue('kosten_heizung') + this.getUserValue('kosten_warmwasser');
          }
          else if (this.getUserValue('kosten_heizung_warmwasser') > 0) {
            userValue = this.getUserValue('kosten_heizung_warmwasser');
          }
          else if (this.getUserValue('kosten_heizung_wasser') > 0) {
            userValue = this.getUserValue('kosten_heizung_wasser');
          }
          image = '/gfx/bkc/heizung.svg';
          buttonlink = this.portalService.getConfig('bekocheck.heizcheck.buttonlink');
          break;
        default:
          const field = 'kosten_' + key;
          userValue = this.getUserValue(field);
          break;
      }

      if (userValue > 0) {
        const userAverage = MathService.roundTo(userValue / this.getUserValue('gebaeude_flaeche'), 2);
        sumUserAverage += userAverage;
        sumAverage += average;
        const note = this.getNote(userAverage, average);
        this.result.costItems.push({
          key,
          position: 'bekochek.ergebnis.' + key + '.label',
          userAverage,
          average,
          note,
          showInfo: false,
          image,
          buttonlink
        });
        if (note > 3) {
          this.result.countOfOverAverage++;
        }
        this.result.maxValue = Math.max(this.result.maxValue, userAverage, average);
      }
    });
    this.result.sumAverage = MathService.roundTo(sumAverage, 2);
    this.result.sumUserAverage = MathService.roundTo(sumUserAverage, 2);
    this.result.note = this.getNote(this.result.sumUserAverage, this.result.sumAverage);
    this.result.mehrkostenGebaeude = MathService.roundTo((this.result.sumUserAverage - this.result.sumAverage) * this.getUserValue('gebaeude_flaeche'), 0);
    this.result.countOfItems = this.result.costItems.length;

    // Kostenpositionen nach Hoehe sortieren (Hoechste zuerst)
    this.result.costItems.sort((a, b) => {
      if (a.userAverage > b.userAverage) {
        return -1;
      }
      if (a.userAverage < b.userAverage) {
        return 1;
      }
      return 0;
    });

    // width for cost-bar
    this.result.costItems.forEach((item) => {
      item.widthUser = MathService.roundTo(item.userAverage * 100 / this.result.maxValue, 2) + '%';
      item.widthAvg = MathService.roundTo(item.average * 100 / this.result.maxValue, 2) + '%';
      item.stage = item.note <= 3 ? 0 : (item.note === 4 ? 1 : 2);
    });

    this.result.kosten_min = MathService.roundTo(this.result.sumAverage * 1.05, 2);
    this.result.kosten_max = MathService.roundTo(this.result.sumAverage * 1.2, 2);
  }

  getNote(value: number, average: number): number {
    let note: number;
    // Deviation in %
    let deviation = 0;
    if (average > 0) {
      deviation = MathService.roundTo(value * 100 / average - 100, 1);
    }
    if (deviation < -20) {
      note = 1;
    }
    else if (deviation >= -20 && deviation < -5) {
      note = 2;
    }
    else if (deviation >= -5 && deviation < 5) {
      note = 3;
    }
    else if (deviation >= 5 && deviation < 20) {
      note = 4;
    }
    else {
      note = 5;
    }
    return note;
  }

  /**
   * create data object that will be sent to the backend with the registration for the dialog
   */
  initDialogData(): void {
    this.requestService.backendService.getRequestId().subscribe(requestId => {
      this.dialogData = {
        requestId: requestId,
        bmOptinSource: window.location.href,
        doisource: 'bkc',
      };
    });
  }

  /**
   * Function is called if the users registered for the dialog
   */
  dialogRegistered(result: string): void {
    const anfrage = this.requestService.getAnfrage();
    anfrage.dialogResult = result;

    this.requestService.setAnfrage(anfrage);
    this.requestService.saveDataToServer();
  }

  /**
   * Reset the request object in the browser and start a new session
   */
  resetRequest(): void {
    this.requestService.resetLocalStorage();
    this.requestService.backendService.resetRequestId();
  }
}
